import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import LayoutContext from '../../contexts/Layout';

const ComponentContainer = props => {
    const { layout } = useContext(LayoutContext);

    return (
        <View
            style={[Style.container, { marginBottom: layout.styleGuide.componentSeparator, marginHorizontal: layout?.styleGuide?.spacer1 }, props.style]}
            dataSet={{
                spacerBottom: `StyleGuide.ComponentSeparator(${layout.styleGuide.componentSeparator})`,
                spacerLeft: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`,
                spacerRight: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`,
                ...props.dataSet
            }}
        >
            {props.children}
        </View>
    );
};

const Style = StyleSheet.create({
    container: {
        backgroundColor: '#fff'
    }
});

ComponentContainer.propTypes = {
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};

export default ComponentContainer;
